import React, { useEffect, useState } from 'react';
import './App.scss';
import { About, Header, Footer, Work, Skills } from './container';
import { Navbar } from './component';

const App = () => {
  const [num,setNum]=useState(0);
  useEffect(()=>console.log("kamal"),[num,setNum]);
  return (

    <div className='app'>
      <Navbar/>
      <Header/>
      <About />
      <Work />
      <Skills />
      <Footer />
    </div>
  )
}

export default App